import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { WhiteButton, Icon, GridCard, TruncateBlock, DLRichTextOutput } from 'appSrc/components/UI';
import LazyImage from 'appSrc/components/Lazy/Image';
import { fixCurrency, convertImage } from 'appSrc/utils/random';
import Like from 'appSrc/components/Like';
import AspectRatio from 'react-aspect-ratio';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';
import style from './styles/style.module.css';


class ProductCard extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = { mounted: false };
    }
    componentDidMount() {
        this.setState( { mounted: true } );
    }
    trackPurchase = () => {
        var product = this.props.product;
        var retailer = /^(?:https?:\/\/)?([^\/\?\:]+)/.exec( product.originalUrl );
        var likes = !product.likes ? 0 : parseInt( product.likes );
        Mixpanel.track( 'productPurchased', {
            id: product.desireid,
            name: product.title,
            price: product.price,
            retailer: retailer[1] || retailer[0],
            // brand: '?',
            date_created: product.dateCreated,
            like_count: likes,
            // purchase_count: 0,
            // view_count: 0,
            // search_count: 0,
            // share_count: 0,
            source_url: product.url,
            author: product.userid,
            list: product.listid,
        } );
    }
    convertImage = ( image ) => {
        var size = '/500x500';
        var clientWidth = this._el && this._el.clientWidth;
        if( clientWidth ) {
            if( clientWidth <= 100 ) {
                size = '/100x100';
            } else if( clientWidth <= 200 ) {
                size = '/200x200';
            } else if( clientWidth <= 300 ) {
                size = '/300x300';
            } else if( clientWidth <= 400 ) {
                size = '/400x400';
            } else if( clientWidth <= 500 ) {
                size = '/500x500';
            } else if( clientWidth <= 600 ) {
                size = '/600x600';
            }
        }
        image = convertImage( image, size );
        return image;
    }


    render() {
        const { product } = this.props;
        const showInfo = !this.props.expand && !this.props.noInfo;
        const image = this.convertImage( product.image );
        return (
            <GridCard className={ `${ style.productCard } ${ this.props.className || '' }` }
            style={ { ...this.props.style } }
            data-expand={ this.props.expand }
            data-draggable={ this.props.draggable }
            data-id={ product.desireid }>
                <Link to={ '/app/products/' + product.desireid + '/' + encodeForURI(product.title) }>
                    <AspectRatio ratio='1/1'>
                        <div className={ style.imageWrapper } ref={ ( el ) => { this._el = el; } } >
                            { this.state.mounted &&
                                <LazyImage source={ image } />
                            }
                        </div>
                    </AspectRatio>
                    <div className={ style.mobileInfo }>
                        <div>
                            <p className={ style.detail } title={ product.title }>{ product.title }</p>
                            <p className={ style.detail }>{ `\$${ fixCurrency( product.price ) }` }</p>
                        </div>
                    </div>
                </Link>
                { showInfo &&
                    <div className={ style.productInformation }>
                        <div className={ style.backgroundImg } />

                        { this.props.self.userid !== product.userid &&
                            <div className={ style.likeWrapper }>
                                <Like
                                size={ 20 }
                                type="product"
                                item={ product }
                                iconStyle={ { fill: 'white' } }
                                onUpdate={ this.props.onLike }/>
                            </div>
                        }

                        <Link to={ '/app/products/' + product.desireid + '/' + encodeForURI(product.title) }
                        className={ style.backgroundLink }
                        title={ product.title }></Link>
                        <div className={ style.productInformationContent }>
                            <div className={ style.title }>{ product.title }</div>
                            <AspectRatio ratio='2/1'>
                                <TruncateBlock className={ style.truncateBlock }>
                                    <DLRichTextOutput className={ style.description } content={ product.description } />
                                </TruncateBlock>
                            </AspectRatio>
                        </div>

                        <div className={ style.controls }>
                            <p className={ style.price }>${ fixCurrency( product.price ) }</p>

                            <a className={ style.purchaseLink } href={ product.url }
                            target='_blank' rel='noopener noreferrer'>
                                <WhiteButton
                                label='Buy'
                                style={ { width: '80px', height: '30px', lineHeight: '30px' } }
                                onClick={ this.trackPurchase } />
                            </a>
                        </div>
                    </div>
                }
                { ( product.deactivated && product.userid == this.props.self.userid ) &&
                    <div className={ style.deactiveIcon } title='Product disabled by Admin'>
                        <Icon source='fontAwesome' icon='far/faTimesCircle' style={ { fontSize: '22px', height: 'auto', width: 'auto', color: 'red' } } />
                    </div>
                }
            </GridCard>
        );
    }
}
ProductCard.defaultProps = {
    product: {},
    onLike: response => response,
};
ProductCard.propTypes = {
    product: PropTypes.object.isRequired,
};

const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
        screenSize: state.screenSize.width,
    };
};

export default connect( mapStateToProps )( ProductCard );
